// 영어 버전 이력서 렌더러 컴포넌트
import React from 'react';
import { Globe } from 'lucide-react';
import LiveResumeTemplate from './LiveResumeTemplate';

const EnglishResumeRenderer = ({ englishData, originalData }) => {
  if (!englishData) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
        <Globe className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-500">영어 버전이 아직 생성되지 않았습니다.</p>
        <p className="text-gray-400 text-sm mt-2">상단의 'EN' 버튼을 눌러 영어 버전을 먼저 생성해주세요.</p>
      </div>
    );
  }

  // 영어 데이터를 LiveResumeTemplate 형식에 맞게 변환
  const convertedResumeData = {
    name: originalData?.name_en || englishData.name || '', // 영어 이름이 있으면 우선 사용
    title: englishData.title || '',
    phone: originalData?.phone || '', // 원본 데이터에서 가져옴
    email: originalData?.email || '', // 원본 데이터에서 가져옴
    github: originalData?.github || '',
    address: originalData?.address || '',
    summary: englishData.summary || '',
    keyStrengths: englishData.key_strengths || [],
    experiences: englishData.experiences || [],
    education: englishData.education || [],
    skills: englishData.skills || [],
    certificates: englishData.certificates || [],
    papers: englishData.papers || [],
    social_links: originalData?.social_links || [] // 원본 데이터에서 가져옴
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      {/* LiveResumeTemplate를 사용하여 동일한 레이아웃으로 영어 데이터 표시 */}
      <LiveResumeTemplate
        resumeData={convertedResumeData}
        updatingField={null}
        language="en" // 영어 버전으로 설정
      />
    </div>
  );
};

export default EnglishResumeRenderer;
